import { render } from "./USDTWithdraw.vue?vue&type=template&id=47e16a6a&scoped=true"
import script from "./USDTWithdraw.vue?vue&type=script&lang=js"
export * from "./USDTWithdraw.vue?vue&type=script&lang=js"

import "./USDTWithdraw.vue?vue&type=style&index=0&id=47e16a6a&lang=less&scoped=true"
import "./USDTWithdraw.vue?vue&type=style&index=1&id=47e16a6a&lang=less"

import exportComponent from "/home/data/jenkins/workspace/Pro_TWI_T/Pro_TWI_h5_advantrade-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47e16a6a"]])

export default __exports__